import {
    isAndroid,
    mobileModel,
    osVersion,
    isIE,
    browserVersion,
    osName,
    isMobileOnly,
    isTablet,
    isBrowser,
    isIOS,
    isFirefox,
} from 'mobile-device-detect';

export function getOsVersion() {
    return osVersion;
}

export function getOsName() {
    return osName;
}

export function getIsIOS() {
    return isIOS;
}
export function deviceIsPhone() {
    return isMobileOnly;
}

export function deviceIsTablet() {
    return isTablet;
}

export function getIsWeb() {
    return isBrowser;
}

export function enableWheelScroll() {
    return !(isIE || isFirefox);
}

export function disableWebGL() {
    if (isAndroid) {
        // A5
        if (mobileModel === 'Galaxy A5') {
            // seems too easy to work
            return true;
        }

        if (parseInt(osVersion.substr(0, osVersion.indexOf('.')), 10) < 7) {
            return true;
        }
    }

    return false;
}

export function disableIAP() {
    if (isAndroid) {
        if (parseInt(osVersion.substr(0, osVersion.indexOf('.')), 10) < 6) {
            return true;
        }
    }

    return false;
}

export function disableBoardAnimations() {
    if (isAndroid) {
        if (parseInt(osVersion.substr(0, osVersion.indexOf('.')), 10) < 7) {
            return true;
        }
    }

    return false;
}

export function disableWebfontLoading() {
    if (isIE) {
        if (parseInt(browserVersion, 10) <= 11) {
            return true;
        }
    }

    return false;
}
